import React from 'react'
import { Dialog as MuiDialog } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledDialog = styled(MuiDialog)({
  '& .MuiPaper-root': {
    padding: 0,
    borderRadius: 18,
    backgroundColor: '#ffffff',
  },
})

export default function Dialog({ children, ...other }) {
  return (
    <StyledDialog fullWidth maxWidth="sm" {...other}>
      {children}
    </StyledDialog>
  )
}
